import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

interface PdfViewerProps {
  fileUrl: string;
  height: number;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ fileUrl, height }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div style={{ height }} className="pdf-viewer-container">
      {/* Hide the internal fullscreen button of React PDF Viewer toolbar */}
      <style>
        {`
          .pdf-viewer-container .rpv-default-layout__toolbar button[aria-label="Full screen"],
          .pdf-viewer-container .rpv-default-layout__toolbar button[aria-label="Enter full screen"],
          .pdf-viewer-container .rpv-default-layout__toolbar button[aria-label="Exit full screen"] {
            display: none !important;
          }
        `}
      </style>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <Viewer fileUrl={fileUrl} plugins={[defaultLayoutPluginInstance]} />
      </Worker>
    </div>
  );
};

export default PdfViewer;
